import PropTypes from "prop-types";

import assignmentPropTypes from "@/assignments/utils/assignmentPropTypes";
import {
  assignmentInfoCss,
  labelCss,
  valueCss,
  assignmentInfoColumnCss,
} from "./StudentAssignmentInformation.style";

const propTypes = {
  assignment: assignmentPropTypes,
  __cssFor: PropTypes.shape({
    information: PropTypes.object,
  }),
};

const StudentAssignmentInformation = ({ assignment, __cssFor }) => {
  const teacherName = assignment?.created_by?.user?.display_name;
  const classroomName = assignment?.assignment_classrooms?.[0]?.name;

  const assignmentInfoColumns = [
    {
      label: "Teacher",
      value: teacherName,
    },
    {
      label: "Class",
      value: classroomName,
    },
  ];

  const renderInfoColumns = () => {
    return assignmentInfoColumns.map((item) => {
      if (!item.value) return null;

      return (
        <div
          key={item.label}
          css={[assignmentInfoColumnCss, __cssFor?.information]}
        >
          <p css={labelCss}>{item.label}</p>
          <p css={valueCss}>{item.value}</p>
        </div>
      );
    });
  };

  return <div css={assignmentInfoCss}>{renderInfoColumns()}</div>;
};

StudentAssignmentInformation.propTypes = propTypes;

export default StudentAssignmentInformation;
